import React, { createContext, useContext, useEffect, useState } from "react";
import { CartItem } from "types";

import { getAuthCookie } from "../utils/authCookies";

type CartContextType = {
  cartItems: CartItem[];
  fetchCart: () => void;
  clearCartItems: () => void;
};

const CartContext = createContext<CartContextType>({
  cartItems: [],
  fetchCart: () => {},
  clearCartItems: () => {},
});

export const CartProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);

  const fetchCart = async () => {
    const token = getAuthCookie("sessionToken");
    const cartId = localStorage.getItem("cart_id");
  
    if (!token || !cartId) {
      setCartItems([]);
      return;
    }
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/carts/${cartId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      const items = data.cart_items || [];
      setCartItems(items);
      
      // Extract and store supplier_id from cart items
      if (items.length > 0 && items[0].supplier_id) {
        localStorage.setItem("supplierId", items[0].supplier_id);
      }
    } catch (err) {
      console.error("Failed to fetch cart", err);
      setCartItems([]);
    }
  };
  
  const clearCartItems = () => {
    setCartItems([]);
  };
  

  useEffect(() => {
    fetchCart();
  }, []);

  return (
    <CartContext.Provider value={{ cartItems, fetchCart, clearCartItems }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
